import { styledLinkStyle, WishListButton } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { FC } from 'react'

type BrandsCardProps = {
  imageSource: string | null
  description: string
  name: string
  brandId: number | null
  isOnWishlist: boolean
  onClickWishlist: () => void
}

export const BrandsCard: FC<BrandsCardProps> = ({
  description,
  imageSource,
  name,
  isOnWishlist,
  brandId,
  onClickWishlist,
}) => {
  return (
    <div
      className={cn(
        'group relative block w-full overflow-hidden truncate whitespace-nowrap',
        'before:absolute before:left-0 before:top-0 before:h-[calc(100%-60px)] before:w-full before:bg-shade-100 before:transition-all before:duration-300 before:ease-in-out before:content-[""]',
        'hover:before:h-full',
      )}
    >
      <div
        className={cn(
          'absolute right-4 top-4 z-10',
          'transition-all duration-100 ease-in-out',
          brandId === null && 'pointer-events-none opacity-25',
        )}
        data-is-disabled={brandId === null ? '' : undefined}
      >
        <WishListButton isOnWishlist={isOnWishlist} onClick={onClickWishlist} />
      </div>
      <div className="relative w-full pt-[100%]">
        {imageSource && (
          <img
            src={imageSource}
            alt={description}
            className="absolute left-1/2 top-1/2 h-auto max-h-[120px] w-auto max-w-[160px] -translate-x-1/2 -translate-y-1/2 transform"
          />
        )}
      </div>
      <div
        className={cn(
          styledLinkStyle,
          'mb-4 inline-block max-w-full border-b border-solid border-current py-5 pb-1 leading-[1.45] opacity-100 outline-0',
          'transition-all duration-100 ease-in-out group-hover:opacity-0',
        )}
        data-default-text
      >
        {name}
      </div>
      <div
        className={cn(
          styledLinkStyle,
          'absolute bottom-0 left-4 z-[1] mb-4 inline-block max-w-full translate-y-2 transform border-b border-solid border-current py-5 pb-1 leading-[1.45] opacity-0 outline-0',
          'transition-all duration-0 ease-in-out group-hover:translate-y-0 group-hover:opacity-100 group-hover:delay-100 group-hover:duration-200',
        )}
        data-hover-text
      >
        {name}
      </div>
    </div>
  )
}
